module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "processLabelInventorycontainer",
    staticClass: "processLabelInventory-container common-container"
  }, [_c('el-row', {
    staticStyle: {
      "width": "100%",
      "height": "30px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "hzpbtn-primary",
    staticStyle: {
      "height": "35px",
      "line-height": "10px",
      "margin-right": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.preStep
    }
  }, [_vm._v("返回到促销标签")]), _vm._v(" "), _c('label', {
    staticClass: "plTitle"
  }, [_vm._v("编辑促销标签")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('LayerPath', {
    ref: "LayerPath",
    staticClass: "layerPath",
    on: {
      "promotionLabelChange": _vm.promotionLabelChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "labelFormData",
    staticClass: "form-data-nopadding",
    staticStyle: {
      "padding": "0px 20px",
      "padding-top": "20px",
      "border-bottom": "1px solid"
    },
    attrs: {
      "model": _vm.labelFormData,
      "rules": _vm.labelRules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-row', {
    staticStyle: {
      "width": "100%",
      "height": "40px",
      "line-height": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名    称",
      "prop": "labelname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.labelFormData.labelname),
      callback: function($$v) {
        _vm.$set(_vm.labelFormData, "labelname", $$v)
      },
      expression: "labelFormData.labelname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "步骤名称",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.steptitleDisabled
    },
    model: {
      value: (_vm.steptitle),
      callback: function($$v) {
        _vm.steptitle = $$v
      },
      expression: "steptitle"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备    注",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.labelFormData.remark),
      callback: function($$v) {
        _vm.$set(_vm.labelFormData, "remark", $$v)
      },
      expression: "labelFormData.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "align": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": ""
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary",
      "disabled": _vm.submitDisabled
    },
    on: {
      "click": function($event) {
        return _vm.handleLabelSubmit('labelFormData')
      }
    }
  }, [_vm._v(_vm._s(!!_vm.labelFormData.plid ? '提交' : '添加'))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "addFormData",
    staticClass: "form-data-nopadding",
    attrs: {
      "model": _vm.addFormData,
      "rules": _vm.addRules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-row', {
    staticStyle: {
      "width": "100%",
      "height": "40px",
      "line-height": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.steptype == 1 || _vm.steptype == 4),
      expression: "steptype == 1 || steptype == 4"
    }],
    attrs: {
      "label": "选择商品",
      "prop": "icode"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchSpList
    },
    model: {
      value: (_vm.addFormData.icode),
      callback: function($$v) {
        _vm.$set(_vm.addFormData, "icode", $$v)
      },
      expression: "addFormData.icode"
    }
  }, _vm._l((_vm.spDatas), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "清除选择的商品",
      "placement": "top",
      "effect": "light"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-close"
    },
    on: {
      "click": function($event) {
        return _vm.clearInventory('sp')
      }
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.steptype == 1 || _vm.steptype == 4),
      expression: "steptype == 1 || steptype == 4"
    }],
    attrs: {
      "label": "商品数量",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    on: {
      "change": function($event) {
        return _vm.codeSizeChange('add')
      }
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.number.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.addFormData.icodesize),
      callback: function($$v) {
        _vm.$set(_vm.addFormData, "icodesize", $$v)
      },
      expression: "addFormData.icodesize"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": (_vm.steptype == 1 || _vm.steptype == 4) ? 8 : 15
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择赠品",
      "prop": "zpcode"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchZpList,
      "disabled": _vm.addZpDisabled
    },
    model: {
      value: (_vm.addFormData.zpcode),
      callback: function($$v) {
        _vm.$set(_vm.addFormData, "zpcode", $$v)
      },
      expression: "addFormData.zpcode"
    }
  }, _vm._l((_vm.zpDatas), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "清除选择的赠品",
      "placement": "top",
      "effect": "light"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-close",
      "disabled": _vm.addZpDisabled
    },
    on: {
      "click": function($event) {
        return _vm.clearInventory('zp')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.steptype == 1 || _vm.steptype == 4),
      expression: "steptype == 1 || steptype == 4"
    }],
    attrs: {
      "span": 5
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "赠品跟随商品",
      "placement": "top",
      "effect": "light"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.addZpDisabled
    },
    on: {
      "click": function($event) {
        return _vm.followInventory('zp')
      }
    }
  }, [_vm._v("跟随商品")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": (_vm.steptype == 1 || _vm.steptype == 4) ? 5 : 9
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "赠品数量",
      "prop": "zpcodesize"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.addZpDisabled
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.zpnumber.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.addFormData.zpcodesize),
      callback: function($$v) {
        _vm.$set(_vm.addFormData, "zpcodesize", $$v)
      },
      expression: "addFormData.zpcodesize"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "width": "100%",
      "height": "40px",
      "line-height": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备    注",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.addFormData.remark),
      callback: function($$v) {
        _vm.$set(_vm.addFormData, "remark", $$v)
      },
      expression: "addFormData.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": ""
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary",
      "disabled": !_vm.labelFormData.plid
    },
    on: {
      "click": function($event) {
        return _vm.handleAddSubmit('addFormData')
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    staticStyle: {
      "margin-left": "50px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品快速搜索",
      "clearable": ""
    },
    on: {
      "change": _vm.searchList
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.searchList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.vagueContent),
      callback: function($$v) {
        _vm.vagueContent = $$v
      },
      expression: "vagueContent"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    slot: "append"
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 55 - 158,
      "highlight-current-row": "",
      "id": "out-table",
      "border": "",
      "row-key": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "商品名称",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "thumimage",
      "label": "图片",
      "align": "center",
      "min-width": "20%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-image', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!!scope.row.thumimage),
            expression: "!!scope.row.thumimage"
          }],
          staticStyle: {
            "width": "50px",
            "height": "50px"
          },
          attrs: {
            "src": scope.row.thumimage,
            "fit": "cover"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "refsaleprice",
      "label": "单价",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "icodesize",
      "label": "数量",
      "formatter": _vm.formatIcodesize,
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zpname",
      "label": "赠品商品",
      "formatter": _vm.formatZpname,
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zpcodesize",
      "label": "赠品数量",
      "formatter": _vm.formatZpcodesize,
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.delData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.enableData(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status === 0 ? '禁用' : '启用'))]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.dialogTitle + '数据',
      "visible": _vm.editDialogVisible,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.steptype == 1 || _vm.steptype == 4),
      expression: "steptype == 1 || steptype == 4"
    }],
    attrs: {
      "label": "选择商品",
      "prop": "icode"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchSpList
    },
    model: {
      value: (_vm.formData.icode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "icode", $$v)
      },
      expression: "formData.icode"
    }
  }, _vm._l((_vm.spDatas), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "width": "20px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "清除选择的商品",
      "placement": "top",
      "effect": "light"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-close"
    },
    on: {
      "click": function($event) {
        return _vm.clearInventory('editsp')
      }
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.steptype == 1 || _vm.steptype == 4),
      expression: "steptype == 1 || steptype == 4"
    }],
    attrs: {
      "label": "商品数量",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    on: {
      "change": function($event) {
        return _vm.codeSizeChange('edit')
      }
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.editnumber.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.formData.icodesize),
      callback: function($$v) {
        _vm.$set(_vm.formData, "icodesize", $$v)
      },
      expression: "formData.icodesize"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择赠品",
      "prop": "zpcode"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchZpList,
      "disabled": _vm.editZpDisabled
    },
    model: {
      value: (_vm.formData.zpcode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "zpcode", $$v)
      },
      expression: "formData.zpcode"
    }
  }, _vm._l((_vm.zpDatas), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "width": "20px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "清除选择的赠品",
      "placement": "top",
      "effect": "light"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-close",
      "disabled": _vm.editZpDisabled
    },
    on: {
      "click": function($event) {
        return _vm.clearInventory('editzp')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.steptype == 1 || _vm.steptype == 4),
      expression: "steptype == 1 || steptype == 4"
    }],
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "赠品跟随商品",
      "placement": "top",
      "effect": "light"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.editZpDisabled
    },
    on: {
      "click": function($event) {
        return _vm.followInventory('editzp')
      }
    }
  }, [_vm._v("跟随商品")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "赠品数量",
      "prop": "zpcodesize"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.editZpDisabled
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.editzpnumber.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.formData.zpcodesize),
      callback: function($$v) {
        _vm.$set(_vm.formData, "zpcodesize", $$v)
      },
      expression: "formData.zpcodesize"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备    注",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "hzpbtn-close",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72c7f7e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/promotionManagement/ProcessLabelInventory.vue
// module id = 714
// module chunks = 1